import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'yearMonth',
  standalone: true
})
export class YearMonth implements PipeTransform {
  constructor() { }
  transform(value: string): string {
    if (Utilities.isEmptyString(value)) {
      return "";
    }

    const date = new Date(value);
    if (!Utilities.isValidDate(date)) {
      return "";
    }

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return (date.getFullYear() + '.' + month);
  }
}
